<template>
  <a :href="route" style="color: inherit;" class="adminCard">
    <div class="card queue-card text-white">
      <div class="card-body row px-4 px-md-2 py-3">
        <div class="col-md-5 col-lg-3 text-center">
          <i class="fas fa-paper-plane fa-4x d-none d-xl-block d-xxl-block mt-2 mt-xl-0"></i>
          <i class="fas fa-paper-plane fa-3x d-none d-md-block d-lg-block d-xl-none mt-2"></i>
          <i
            class="fas fa-paper-plane fa-3x d-block d-md-none position-absolute mt-2"
            style="right:16px;"
          ></i>
        </div>
        <div class="col-md-7 col-lg-9">
          <h3 v-if="!loading">
            <strong>{{ postingQueueCount }}</strong>
          </h3>
          <h3 v-else>
            <i class="fa fa-spinner fa-pulse fa-fw"></i>
          </h3>
          <div class="d-block d-lg-none">Queue</div>
          <div class="d-none d-lg-block">Posting Queue</div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "PostingQueueCard",

  props: {
    route: {
      required: true,
      type: String
    }
  },

  data() {
    return {
      loading: false,
      postingQueueCount: 0
    };
  },

  created() {
    this.loadPostingQueue();
  },

  methods: {
    loadPostingQueue() {
      this.loading = true;
      var self = this;
      axios
        .get("api/queues/posting/count")
        .then(function(response) {
          self.loading = false;
          // convert to an array (so we can easily get the length)
          self.postingQueueCount = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>